import * as React from "react"
import type { SVGProps } from "react"

export const ChatFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="m6.038 17.5-2.002 2.002q-.426.426-.981.192-.555-.235-.555-.84V4.308q0-.758.525-1.283T4.308 2.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zM7 13.75h6q.319 0 .534-.216A.73.73 0 0 0 13.75 13a.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.216H7a.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534q0 .32.216.534A.73.73 0 0 0 7 13.75m0-3h10q.318 0 .534-.216A.73.73 0 0 0 17.75 10a.73.73 0 0 0-.216-.534A.73.73 0 0 0 17 9.25H7a.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534q0 .32.216.534A.73.73 0 0 0 7 10.75m0-3h10q.318 0 .534-.216A.73.73 0 0 0 17.75 7a.73.73 0 0 0-.216-.535A.73.73 0 0 0 17 6.25H7a.73.73 0 0 0-.534.216A.73.73 0 0 0 6.25 7q0 .32.216.535A.73.73 0 0 0 7 7.75"
    ></path>
  </svg>
)
